import { initializeHeader } from "./header";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
import { mockWait } from "../mock/fieldSurveyMock";
import { startProgressDisplay, advanceProgress, endProgressDisplay } from "../modules/uiManager/UiProgressDisplay";
import { getUserInformationCached } from "../modules/userManager/UserManager";
import { showPopupAlert, showPopupConfirm } from "../modules/uiManager/UiPopup";
import { populateSelect, isCodeMasterLoaded, fetchCodeMaster, setCodeMaster } from "../modules/codeMasterManager/CodeMasterManager";
import { openCandidateSearch, openStoreSearch, openEmployeeSearch, openVendorSearch } from "../modules/searchModal/SearchModalConfigs";
import { uploadGcsFile, deleteGcsFile } from "../apis/firebaseStorage";
import { initNewRequest, registerFieldSurveyRequest, getApiErrorMessage } from "../apis/fieldSurveyRequestApi";
import { loadMockZoData, loadMockDoData, getAllZone, getAllDo } from "../data/zodoData";
import { fetchOperationPermissions } from "../apis/graphqlClient";
import { getOperationPermission, setOperationPermissions, isOperationPermissionsLoaded } from "../modules/permissionManager/PermissionManager";
const REQUIRED_DOCUMENTS_NEW = [
    '公図', '住宅地図', '敷地実測図', '簡易CAD', '簡易概算'
];
const OPTIONAL_DOCUMENTS = [
    '土地謄本', '建物謄本', '配置プラン', '店内レイアウト/ビル図面'
];
const STORE_SEARCH_ENABLED_TYPES = ['020', '030', '031', '032'];
const PARKING_EXPANSION_TYPES = ['030', '031', '032'];
let documentRows = [];
const FORM_FIELD_IDS = [
    'txtCandidateId', 'txtStoreName', 'txtStoreNameKana', 'txtAddress',
    'dtOpenDate', 'dtSurveyDesiredDate', 'dtReportDueDate', 'txtRemarks',
    'selPrefecture', 'selZO', 'selDO', 'selContractType', 'selOwnership',
    'selBuildingType', 'selLicense', 'selSubmissionMethod', 'chkConfirmation',
];
const FORM_BUTTON_IDS = [
    'btnCandidateSearch', 'btnApproverSearch', 'btnDmSearch',
    'btnDesignOfficeSearch', 'btnAddDocument', 'btnRequest',
];
function setFormDisabledState(disabled) {
    FORM_FIELD_IDS.forEach(id => {
        const el = document.getElementById(id);
        if (el)
            el.disabled = disabled;
    });
    FORM_BUTTON_IDS.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
            el.disabled = disabled;
            el.style.opacity = disabled ? '0.5' : '1';
        }
    });
}
function updateStoreSearchState(handlingType) {
    const btn = document.getElementById('btnStoreSearch');
    const input = document.getElementById('txtStoreNo');
    const enabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    if (btn) {
        btn.disabled = !enabled;
        btn.style.opacity = enabled ? '1' : '0.5';
    }
    if (input) {
        input.disabled = !enabled;
        if (!enabled) {
            input.value = '';
            input.classList.add('form-input-disabled');
        }
        else {
            input.classList.remove('form-input-disabled');
        }
    }
}
function updateRequiredMarks(handlingType) {
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const isStoreEnabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    const candidateLabel = document.getElementById('txtCandidateId')?.parentElement?.previousElementSibling;
    const storeLabel = document.getElementById('txtStoreNo')?.parentElement?.previousElementSibling;
    if (candidateLabel) {
        candidateLabel.classList.toggle('required', !isParkingType && !!handlingType);
    }
    if (storeLabel) {
        storeLabel.classList.toggle('required', isStoreEnabled);
    }
}
function onHandlingTypeChange(handlingType) {
    setFormDisabledState(!handlingType);
    updateStoreSearchState(handlingType);
    updateRequiredMarks(handlingType);
    const currentState = new Map();
    const customRows = [];
    documentRows.forEach(row => {
        if (row.isCustom) {
            customRows.push(row);
        }
        else {
            currentState.set(row.documentName, row);
        }
    });
    documentRows = [];
    REQUIRED_DOCUMENTS_NEW.forEach(name => {
        documentRows.push(currentState.get(name) || { documentName: name, fileName: '', uploader: '', uploadDate: '', isCustom: false, gcsPath: '' });
    });
    OPTIONAL_DOCUMENTS.forEach(name => {
        documentRows.push(currentState.get(name) || { documentName: name, fileName: '', uploader: '', uploadDate: '', isCustom: false, gcsPath: '' });
    });
    customRows.forEach(row => documentRows.push(row));
    renderDocumentTable();
}
function setupHandlingTypeControl() {
    const sel = document.getElementById('selHandlingType');
    if (!sel)
        return;
    sel.addEventListener('change', () => onHandlingTypeChange(sel.value));
    updateStoreSearchState(sel.value);
    updateRequiredMarks(sel.value);
}
function getTodayString() {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const mm = String(now.getMinutes()).padStart(2, '0');
    const ss = String(now.getSeconds()).padStart(2, '0');
    return `${y}/${m}/${d} ${hh}:${mm}:${ss}`;
}
function initializeFormSelects() {
    populateSelect('selHandlingType', 'handling_type', '選択してください');
    populateSelect('selPrefecture', 'prefecture', '選択してください');
    populateSelect('selContractType', 'contract_type', '選択してください');
    populateSelect('selOwnership', 'ownership_type', '選択してください');
    populateSelect('selBuildingType', 'building_type', '選択してください');
    populateSelect('selLicense', 'license_plan', '選択してください');
    populateSelect('selSubmissionMethod', 'submission_method', '選択してください');
}
function populateZoSelect() {
    const sel = document.getElementById('selZO');
    if (!sel)
        return;
    const zone = getAllZone();
    let html = '<option value="">-- 選択 --</option>';
    for (const key in zone.zone_data) {
        const z = zone.zone_data[key];
        html += `<option value="${z.zone_code}">${z.zone_name}</option>`;
    }
    sel.innerHTML = html;
}
function populateDoSelect() {
    const sel = document.getElementById('selDO');
    if (!sel)
        return;
    const doInfo = getAllDo();
    let html = '<option value="">-- 選択 --</option>';
    for (const key in doInfo.do_data) {
        const d = doInfo.do_data[key];
        html += `<option value="${d.do_code}">${d.do_name}</option>`;
    }
    sel.innerHTML = html;
}
async function initializeBasicInfo() {
    const lblInternalId = document.getElementById('lblInternalId');
    try {
        const result = await initNewRequest();
        if (lblInternalId)
            lblInternalId.value = result.internalId;
        if (result.manager) {
            const txtApprover = document.getElementById('txtApprover');
            const txtApproverCode = document.getElementById('txtApproverCode');
            if (txtApprover)
                txtApprover.value = result.manager.employeeName;
            if (txtApproverCode)
                txtApproverCode.value = result.manager.employeeCode;
        }
    }
    catch (error) {
        console.error('初期化データの取得に失敗:', error);
        if (lblInternalId)
            lblInternalId.value = '';
    }
    const lblRequestDate = document.getElementById('lblRequestDate');
    if (lblRequestDate) {
        lblRequestDate.value = getTodayString();
    }
}
async function initializeRequester() {
    try {
        const userInfo = await getUserInformationCached(false);
        const employeeName = userInfo?.[0]?.employee_name || '';
        const employeeNo = userInfo?.[0]?.employee_no || '';
        const txtRequester = document.getElementById('txtRequester');
        if (txtRequester)
            txtRequester.value = employeeName;
        const txtRequesterCode = document.getElementById('txtRequesterCode');
        if (txtRequesterCode)
            txtRequesterCode.value = employeeNo;
    }
    catch (error) {
        console.error('依頼者情報の取得に失敗:', error);
    }
}
function initializeDocumentTable() {
    const sel = document.getElementById('selHandlingType');
    const handlingType = sel?.value || '';
    documentRows = [];
    REQUIRED_DOCUMENTS_NEW.forEach(name => {
        documentRows.push({ documentName: name, fileName: '', uploader: '', uploadDate: '', isCustom: false, gcsPath: '' });
    });
    OPTIONAL_DOCUMENTS.forEach(name => {
        documentRows.push({ documentName: name, fileName: '', uploader: '', uploadDate: '', isCustom: false, gcsPath: '' });
    });
    renderDocumentTable();
}
function renderDocumentTable() {
    const tbody = document.getElementById('documentTableBody');
    if (!tbody)
        return;
    let html = '';
    documentRows.forEach((row, index) => {
        const isRequired = REQUIRED_DOCUMENTS_NEW.includes(row.documentName);
        html += `
      <tr>
        <td>
          ${row.isCustom
            ? `<input type="text" class="doc-name-input" data-index="${index}" value="${escapeHtml(row.documentName)}" placeholder="書類名を入力" />`
            : `<span>${isRequired ? '<span class="required-mark">●</span> ' : ''}${escapeHtml(row.documentName)}</span>`}
        </td>
        <td>${escapeHtml(row.fileName)}</td>
        <td>${escapeHtml(row.uploader)}</td>
        <td>${escapeHtml(row.uploadDate)}</td>
        <td>
          <button type="button" class="pill-button-outline doc-upload-btn" data-index="${index}" style="padding: 4px 12px; font-size: 12px;">
            <span class="material-icons" style="font-size: 14px;">upload_file</span>選択
          </button>
          <input type="file" class="doc-file-input" data-index="${index}" style="display: none;" />
        </td>
        <td>
          ${row.fileName
            ? `<button type="button" class="doc-delete-btn" data-index="${index}" style="background:none;border:none;cursor:pointer;color:#d32f2f;">
                <span class="material-icons">delete</span>
              </button>`
            : (row.isCustom
                ? `<button type="button" class="doc-remove-row-btn" data-index="${index}" style="background:none;border:none;cursor:pointer;color:#999;">
                  <span class="material-icons">close</span>
                </button>`
                : '')}
        </td>
      </tr>
    `;
    });
    tbody.innerHTML = html;
    setupDocumentEventListeners();
}
function setupDocumentEventListeners() {
    document.querySelectorAll('.doc-upload-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            const fileInput = document.querySelector(`.doc-file-input[data-index="${index}"]`);
            if (fileInput)
                fileInput.click();
        });
    });
    document.querySelectorAll('.doc-file-input').forEach(input => {
        input.addEventListener('change', async (e) => {
            const target = e.target;
            const index = parseInt(target.dataset.index || '0', 10);
            const file = target.files?.[0];
            if (!file || !documentRows[index])
                return;
            const autoFileName = generateAutoFileName(file, documentRows[index]);
            const internalId = getInternalId();
            const gcsPath = `${internalId}/${autoFileName}`;
            const uploadBtn = document.querySelector(`.doc-upload-btn[data-index="${index}"]`);
            if (uploadBtn) {
                uploadBtn.disabled = true;
                uploadBtn.innerHTML = '<span class="material-icons" style="font-size: 14px;">hourglass_top</span>0%';
            }
            try {
                await uploadGcsFile(gcsPath, file, (percent) => {
                    if (uploadBtn) {
                        uploadBtn.innerHTML = `<span class="material-icons" style="font-size: 14px;">hourglass_top</span>${percent}%`;
                    }
                });
                documentRows[index].fileName = autoFileName;
                documentRows[index].uploader = document.getElementById('txtRequester')?.value || '';
                documentRows[index].uploadDate = getTodayString();
                documentRows[index].gcsPath = gcsPath;
                renderDocumentTable();
            }
            catch (error) {
                console.error('ファイルアップロードに失敗:', error);
                showPopupAlert({ text: 'ファイルのアップロードに失敗しました。', showBackdrop: true });
                if (uploadBtn) {
                    uploadBtn.disabled = false;
                    uploadBtn.innerHTML = '<span class="material-icons" style="font-size: 14px;">upload_file</span>選択';
                }
            }
        });
    });
    document.querySelectorAll('.doc-delete-btn').forEach(btn => {
        btn.addEventListener('click', async () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            if (!documentRows[index])
                return;
            const gcsPath = documentRows[index].gcsPath;
            if (gcsPath) {
                try {
                    await deleteGcsFile(gcsPath);
                }
                catch (error) {
                    console.error('GCSファイル削除に失敗:', error);
                }
            }
            documentRows[index].fileName = '';
            documentRows[index].uploader = '';
            documentRows[index].uploadDate = '';
            documentRows[index].gcsPath = '';
            renderDocumentTable();
        });
    });
    document.querySelectorAll('.doc-remove-row-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            documentRows.splice(index, 1);
            renderDocumentTable();
        });
    });
    document.querySelectorAll('.doc-name-input').forEach(input => {
        input.addEventListener('change', (e) => {
            const target = e.target;
            const index = parseInt(target.dataset.index || '0', 10);
            if (documentRows[index]) {
                documentRows[index].documentName = target.value;
            }
        });
    });
}
function generateAutoFileName(file, row) {
    if (row.isCustom)
        return file.name;
    const now = new Date();
    const yyyymmdd = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
    const handlingType = document.getElementById('selHandlingType')?.value || '';
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const identifier = isParkingType
        ? document.getElementById('txtStoreNo')?.value || ''
        : document.getElementById('txtCandidateId')?.value || '';
    const seqNo = 1;
    const sanitizedDocName = row.documentName.replace(/\//g, '_');
    const ext = file.name.includes('.') ? file.name.split('.').pop() || '' : '';
    return `${yyyymmdd}_${seqNo}_${identifier}_${sanitizedDocName}.${ext}`;
}
function getInternalId() {
    return document.getElementById('lblInternalId')?.value || '';
}
function escapeHtml(str) {
    if (!str)
        return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
function collectFormData() {
    const getVal = (id) => {
        const el = document.getElementById(id);
        return el ? el.value.trim() : '';
    };
    const chk = document.getElementById('chkConfirmation');
    return {
        internalId: getVal('lblInternalId'),
        handlingType: getVal('selHandlingType'),
        candidateId: getVal('txtCandidateId'),
        storeNo: getVal('txtStoreNo'),
        storeName: getVal('txtStoreName'),
        storeNameKana: getVal('txtStoreNameKana'),
        prefecture: getVal('selPrefecture'),
        zo: getVal('selZO'),
        do: getVal('selDO'),
        address: getVal('txtAddress'),
        contractType: getVal('selContractType'),
        ownership: getVal('selOwnership'),
        buildingType: getVal('selBuildingType'),
        license: getVal('selLicense'),
        openDate: getVal('dtOpenDate'),
        surveyDesiredDate: getVal('dtSurveyDesiredDate'),
        reportDueDate: getVal('dtReportDueDate'),
        submissionMethod: getVal('selSubmissionMethod'),
        confirmation: chk ? chk.checked : false,
        remarks: getVal('txtRemarks'),
        requesterCode: getVal('txtRequesterCode'),
        approverCode: getVal('txtApproverCode'),
        dmCode: getVal('txtDmCode'),
        designOfficeCode: getVal('txtDesignOfficeCode'),
        documents: documentRows
            .filter(r => r.fileName)
            .map(r => ({
            documentType: r.isCustom ? 'optional_file' : r.documentName,
            documentName: r.documentName,
            fileName: r.fileName,
            gcsPath: r.gcsPath,
        })),
    };
}
function setupButtons() {
    const btnBack = document.getElementById('btnBack');
    if (btnBack) {
        btnBack.addEventListener('click', (e) => {
            e.preventDefault();
            showPopupConfirm({
                text: '一覧画面に戻りますか。入力内容はクリアされます。',
                showBackdrop: true,
                onConfirm: () => navigate('/field-survey-request-list')
            });
        });
    }
    const btnRequest = document.getElementById('btnRequest');
    if (btnRequest) {
        btnRequest.addEventListener('click', () => {
            if (!validateForm())
                return;
            showPopupConfirm({
                text: '依頼を行いますか。',
                showBackdrop: true,
                onConfirm: async () => {
                    try {
                        startLoadingDisplay();
                        const result = await registerFieldSurveyRequest(collectFormData());
                        endLoadingDisplay();
                        const message = result.boxUploadFailed
                            ? '現地調査依頼が完了しました。\n※BOXへの書類格納に失敗しました。管理者にお問い合わせください。'
                            : '現地調査依頼が完了しました。';
                        showPopupAlert({ text: message, showBackdrop: true, onClose: () => navigate('/field-survey-request-list') });
                    }
                    catch (error) {
                        endLoadingDisplay();
                        console.error('依頼登録に失敗:', error);
                        showPopupAlert({ text: getApiErrorMessage(error, '依頼の登録に失敗しました。しばらく時間をおいて再度お試しください。'), showBackdrop: true });
                    }
                }
            });
        });
    }
    const btnAddDocument = document.getElementById('btnAddDocument');
    if (btnAddDocument) {
        btnAddDocument.addEventListener('click', () => {
            documentRows.push({ documentName: '', fileName: '', uploader: '', uploadDate: '', isCustom: true, gcsPath: '' });
            renderDocumentTable();
        });
    }
    const btnCandidateSearch = document.getElementById('btnCandidateSearch');
    if (btnCandidateSearch) {
        btnCandidateSearch.addEventListener('click', () => openCandidateSearch());
    }
    const btnStoreSearch = document.getElementById('btnStoreSearch');
    if (btnStoreSearch) {
        btnStoreSearch.addEventListener('click', () => openStoreSearch());
    }
    const btnApproverSearch = document.getElementById('btnApproverSearch');
    if (btnApproverSearch) {
        btnApproverSearch.addEventListener('click', () => openEmployeeSearch('txtApprover', 'txtApproverCode', 'APPROVER'));
    }
    const btnDmSearch = document.getElementById('btnDmSearch');
    if (btnDmSearch) {
        btnDmSearch.addEventListener('click', () => openEmployeeSearch('txtDm', 'txtDmCode', 'DM'));
    }
    const btnDesignOfficeSearch = document.getElementById('btnDesignOfficeSearch');
    if (btnDesignOfficeSearch) {
        btnDesignOfficeSearch.addEventListener('click', () => openVendorSearch('txtDesignOffice', 'txtDesignOfficeCode'));
    }
}
function validateForm() {
    const handlingType = document.getElementById('selHandlingType')?.value || '';
    const isStoreEnabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const requiredFields = [
        { id: 'selHandlingType', name: '取扱区分' },
        ...(!isParkingType ? [{ id: 'txtCandidateId', name: '候補地番号' }] : []),
        ...(isStoreEnabled ? [{ id: 'txtStoreNo', name: '店番' }] : []),
        { id: 'txtStoreName', name: '店名' },
        { id: 'selPrefecture', name: '都道府県' },
        { id: 'selZO', name: 'ZO' },
        { id: 'selDO', name: 'DO' },
        { id: 'selContractType', name: '契約タイプ' },
        { id: 'selOwnership', name: '契約形態(所有区分)' },
        { id: 'selBuildingType', name: '建物種類' },
        { id: 'dtOpenDate', name: '開店予定日' },
        { id: 'dtSurveyDesiredDate', name: '現地調査希望日' },
        { id: 'dtReportDueDate', name: '現地調査報告書提出予定日' },
        { id: 'selSubmissionMethod', name: '提出方法' },
        { id: 'txtRequester', name: '依頼者' },
        { id: 'txtApprover', name: '部門承認者' },
        { id: 'txtDm', name: 'DM' },
    ];
    const emptyFields = [];
    let hasError = false;
    requiredFields.forEach(({ id, name }) => {
        const el = document.getElementById(id);
        if (el) {
            const value = el.value.trim();
            if (!value) {
                el.style.borderColor = '#d32f2f';
                emptyFields.push(name);
                hasError = true;
            }
            else {
                el.style.borderColor = '';
            }
        }
    });
    const chk = document.getElementById('chkConfirmation');
    if (chk && !chk.checked) {
        emptyFields.push('確認事項');
        hasError = true;
    }
    if (hasError) {
        showPopupAlert({ text: `必須項目を入力してください。（${emptyFields.join('、')}）`, showBackdrop: true });
        return false;
    }
    const formatRules = [
        { id: 'txtCandidateId', name: '候補地番号', pattern: /^[a-zA-Z0-9]*$/, format: '半角英数字' },
        { id: 'txtStoreNo', name: '店番', pattern: /^[0-9]*$/, format: '半角数字' },
        { id: 'txtStoreName', name: '店名', pattern: /^[^\x20-\x7E]*$/, format: '全角' },
        { id: 'txtStoreNameKana', name: '店名カナ', pattern: /^[^\x20-\x7E]*$/, format: '全角' },
    ];
    const formatErrors = [];
    formatRules.forEach(({ id, name, pattern, format }) => {
        const el = document.getElementById(id);
        if (el && el.value && !el.disabled && !pattern.test(el.value)) {
            el.style.borderColor = '#d32f2f';
            formatErrors.push(`${name}(${format})`);
        }
    });
    if (formatErrors.length > 0) {
        showPopupAlert({ text: `入力形式が不適切です。（${formatErrors.join('、')}）`, showBackdrop: true });
        return false;
    }
    const missingDocs = REQUIRED_DOCUMENTS_NEW.filter(docName => {
        const row = documentRows.find(r => r.documentName === docName);
        return !row || !row.fileName;
    });
    if (missingDocs.length > 0) {
        const tbody = document.getElementById('documentTableBody');
        if (tbody) {
            const rows = tbody.querySelectorAll('tr');
            documentRows.forEach((row, index) => {
                if (rows[index]) {
                    if (missingDocs.includes(row.documentName)) {
                        rows[index].style.backgroundColor = '#fde0dc';
                    }
                    else {
                        rows[index].style.backgroundColor = '';
                    }
                }
            });
        }
        showPopupAlert({ text: `必須書類が未添付です。（${missingDocs.join('、')}）`, showBackdrop: true });
        return false;
    }
    return true;
}
export const initializeFieldSurveyRequestNew = async () => {
    try {
        // 進捗の母数は3（マスタ取得(list×2)・採番(graphql)・ユーザー情報取得(get-user-information)）。
        // 最初の段階には、ヘッダーのユーザー情報・操作権限・コードマスタの取得（未取得の場合のみ通信）も含む
        startProgressDisplay(3, 'ユーザー・権限・マスタ情報を取得中');
        const content = await getHtml('/parts/fieldSurveyRequestNew.html');
        const subContents = document.getElementById('subContents');
        if (content && subContents) {
            subContents.innerHTML = content;
        }
        await initializeHeader('現地調査依頼');
        if (!isOperationPermissionsLoaded()) {
            const ops = await fetchOperationPermissions();
            setOperationPermissions(ops);
        }
        const op = getOperationPermission('SITE_SURVEY');
        if (op && !op.ssNewRequest) {
            endProgressDisplay();
            await showPopupAlert({ text: '新規依頼の権限がありません。', showBackdrop: true });
            navigate('/fieldSurveyRequest');
            return;
        }
        if (!isCodeMasterLoaded()) {
            const codeMaster = await fetchCodeMaster();
            setCodeMaster(codeMaster);
        }
        await Promise.all([loadMockZoData(), loadMockDoData()]);
        await mockWait();
        advanceProgress('内製化識別番号を採番中');
        initializeFormSelects();
        populateZoSelect();
        populateDoSelect();
        await initializeBasicInfo();
        await mockWait();
        advanceProgress('ユーザーデータを取得中');
        await initializeRequester();
        await mockWait();
        advanceProgress('ユーザーデータを取得中');
        await mockWait(400);
        setupHandlingTypeControl();
        setFormDisabledState(true);
        initializeDocumentTable();
        setupButtons();
        endProgressDisplay();
    }
    catch (error) {
        console.error('新規依頼画面の初期化に失敗しました:', error);
        endProgressDisplay();
        throw error;
    }
};
